export const validateCongressmanForm = (formFields) => {
  if (formFields.photo === "") {
    return "Required photo.";
  }

  if (
    formFields.cosNumber?.length > 2 &&
    !/^(09)\d{9}$/.test(formFields?.cosNumber)
  ) {
    return "Invalid cos contact number.";
  }

  return true;
};
